/* Makerz v1 – PDP gallery, variant select, sticky ATC, gift progress. Kun i ikke-publiceret kopi. */
(function(){
  function money(cents){
    try{ return (cents/100).toLocaleString('da-DK',{minimumFractionDigits:2,maximumFractionDigits:2})+' kr'; }catch(e){ return (cents/100).toFixed(2)+' kr'; }
  }
  /* Gallery */
  document.querySelectorAll('[data-mkz-gal]').forEach(function(g){
    var track=g.querySelector('.mkz-gal__track'); if(!track) return;
    var thumbs=g.querySelectorAll('.mkz-gal__thumb'); var dots=g.querySelectorAll('.mkz-gal__dots i');
    function setActive(i){
      thumbs.forEach(function(t,k){ t.setAttribute('aria-current', k===i?'true':'false'); });
      dots.forEach(function(d,k){ d.classList.toggle('on',k===i); });
    }
    thumbs.forEach(function(t,i){ t.addEventListener('click',function(){ track.scrollTo({left:track.clientWidth*i,behavior:'smooth'}); setActive(i); }); });
    var to; track.addEventListener('scroll',function(){ clearTimeout(to); to=setTimeout(function(){ setActive(Math.round(track.scrollLeft/track.clientWidth)); },60); },{passive:true});
    setActive(0);
  });
  /* Variant select */
  document.querySelectorAll('[data-mkz-variant]').forEach(function(sel){
    var root=sel.closest('[data-mkz-pdp]'); if(!root) return;
    sel.addEventListener('change',function(){
      var o=sel.options[sel.selectedIndex];
      root.querySelectorAll('input[name="id"]').forEach(function(i){ i.value=o.value; });
      root.querySelectorAll('[data-mkz-price]').forEach(function(p){ p.textContent=o.dataset.price; });
      var was=root.querySelector('[data-mkz-was]'); if(was){ was.textContent=o.dataset.compare||''; was.hidden=!o.dataset.compare; }
      var avail=o.dataset.available==='true';
      root.querySelectorAll('.mkz-atc,[data-mkz-sticky-btn]').forEach(function(b){ if(avail){b.removeAttribute('aria-disabled');}else{b.setAttribute('aria-disabled','true');} });
      try{ var u=new URL(location.href); u.searchParams.set('variant',o.value); history.replaceState({},'',u); }catch(e){}
    });
  });
  /* Sticky ATC */
  document.querySelectorAll('[data-mkz-sticky]').forEach(function(st){
    var target=document.querySelector(st.dataset.target); if(!target) return;
    var btn=st.querySelector('[data-mkz-sticky-btn]');
    if(btn) btn.addEventListener('click',function(){ var b=target.querySelector('button[type="submit"]'); if(b) b.click(); });
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){ es.forEach(function(e){ var below=e.boundingClientRect.top<0; st.classList.toggle('is-on', !e.isIntersecting && below); }); },{threshold:0}).observe(target);
    }
  });
  /* Gift progress (PDP) */
  var gifts=document.querySelectorAll('[data-mkz-gift]');
  function updateGift(){
    if(!gifts.length) return;
    fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
      gifts.forEach(function(g){
        var th=parseInt(g.dataset.threshold,10)||0; if(!th) return;
        var tot=c.total_price||0; var rem=th-tot; var pct=Math.min(100,Math.round(tot*100/th));
        var t=g.querySelector('[data-mkz-gift-text]'); var b=g.querySelector('[data-mkz-gift-bar]');
        if(t){ t.innerHTML = rem>0 ? g.dataset.textRemaining.replace('[amount]','<b>'+money(rem)+'</b>') : g.dataset.textDone; }
        if(b) b.style.width=pct+'%';
      });
    }).catch(function(){});
  }
  updateGift();
  if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined'){ subscribe(PUB_SUB_EVENTS.cartUpdate,function(){ setTimeout(updateGift,150); }); }
  document.addEventListener('cart:updated',updateGift);
})();
